// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customer messages, review requests and the "on the way" dialog. Every selector is scoped to
   .notifications-page; dialogs get it as rootClassName because they render outside the page. */

.notifications-page .nt-title {
  margin-block-end: var(--ds-space-1, 4px);
}

.notifications-page .nt-full,
.notifications-page .nt-filter {
  width: 100%;
}

.notifications-page .nt-filter {
  min-width: 180px;
  max-width: 260px;
}

.notifications-page .nt-gap {
  margin-block-end: 16px;
}

.notifications-page .nt-card {
  margin-block-end: 16px;
}

.notifications-page .nt-actions {
  display: flex;
  justify-content: flex-end;
  margin-block: 8px 24px;
}

.notifications-page .nt-small {
  font-size: 13px;
  color: var(--ds-text-muted);
}

.notifications-page .nt-wrap {
  overflow-wrap: anywhere;
  margin-block-end: 0;
}

.notifications-page .nt-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

.notifications-page .nt-center {
  display: flex;
  justify-content: center;
  padding-block: 48px;
}

/* Channel order */
.notifications-page .nt-order {
  list-style: none;
  margin: 0;
  padding: 0;
}

.notifications-page .nt-order li {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-block: 8px;
  border-block-end: 1px solid var(--ds-border, rgba(0, 0, 0, 0.06));
  counter-increment: channel;
}

.notifications-page .nt-order li::before {
  content: counter(channel) ".";
  min-width: 20px;
  color: var(--ds-text-muted);
}

.notifications-page .nt-order-name {
  font-weight: 600;
}

.notifications-page .nt-order-actions {
  margin-inline-start: auto;
}

.notifications-page .nt-order-actions .ant-btn {
  min-width: 40px;
  min-height: 40px;
}

/* Template preview */
.notifications-page .nt-preview {
  margin-block-end: 16px;
  padding: 12px;
  border-radius: 8px;
  background: var(--ds-surface-muted, rgba(0, 0, 0, 0.03));
}

.notifications-page .nt-preview-text {
  white-space: pre-line;
  overflow-wrap: anywhere;
  margin-block-start: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/notifications/notifications.css"],"names":[],"mappings":"AAAA;+FAC+F;;AAE/F;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iEAAiE;EACjE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;AACzB","sourcesContent":["/* Customer messages, review requests and the \"on the way\" dialog. Every selector is scoped to\n   .notifications-page; dialogs get it as rootClassName because they render outside the page. */\n\n.notifications-page .nt-title {\n  margin-block-end: var(--ds-space-1, 4px);\n}\n\n.notifications-page .nt-full,\n.notifications-page .nt-filter {\n  width: 100%;\n}\n\n.notifications-page .nt-filter {\n  min-width: 180px;\n  max-width: 260px;\n}\n\n.notifications-page .nt-gap {\n  margin-block-end: 16px;\n}\n\n.notifications-page .nt-card {\n  margin-block-end: 16px;\n}\n\n.notifications-page .nt-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-block: 8px 24px;\n}\n\n.notifications-page .nt-small {\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n.notifications-page .nt-wrap {\n  overflow-wrap: anywhere;\n  margin-block-end: 0;\n}\n\n.notifications-page .nt-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n\n.notifications-page .nt-center {\n  display: flex;\n  justify-content: center;\n  padding-block: 48px;\n}\n\n/* Channel order */\n.notifications-page .nt-order {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.notifications-page .nt-order li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-block: 8px;\n  border-block-end: 1px solid var(--ds-border, rgba(0, 0, 0, 0.06));\n  counter-increment: channel;\n}\n\n.notifications-page .nt-order li::before {\n  content: counter(channel) \".\";\n  min-width: 20px;\n  color: var(--ds-text-muted);\n}\n\n.notifications-page .nt-order-name {\n  font-weight: 600;\n}\n\n.notifications-page .nt-order-actions {\n  margin-inline-start: auto;\n}\n\n.notifications-page .nt-order-actions .ant-btn {\n  min-width: 40px;\n  min-height: 40px;\n}\n\n/* Template preview */\n.notifications-page .nt-preview {\n  margin-block-end: 16px;\n  padding: 12px;\n  border-radius: 8px;\n  background: var(--ds-surface-muted, rgba(0, 0, 0, 0.03));\n}\n\n.notifications-page .nt-preview-text {\n  white-space: pre-line;\n  overflow-wrap: anywhere;\n  margin-block-start: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
